import { useMemo } from 'react';
import { Index, Configure } from 'react-instantsearch';
import { useInstantSearch, useSearchBox } from 'react-instantsearch-core';
import getConfig from 'next/config';
import { generateCollectionIndexName } from '@monofront/business/utils';
import { COLLECTION_TYPE_FILTER } from '@monofront/business/constants';
import { EmptyObject, ICollectionTag } from '@monofront/types';
import HeroCollection from './HeroCollection';
import { useLocale } from 'next-intl';

const {
  publicRuntimeConfig: { algoliaConfig },
} = getConfig();

const CollectionsResults = () => {
  const { results } = useInstantSearch();

  const locale = useLocale();
  const collectionIndexName = generateCollectionIndexName(
    algoliaConfig.environment,
    locale,
  );

  // Patch: filter hasResult on the correct indexName and the presence of query
  // because result of Product Search is retrieve in the firsts renderings
  const hasResults =
    results &&
    results.query &&
    results.index === collectionIndexName &&
    results.nbHits !== 0;

  const collectionHits: ICollectionTag[] = useMemo(() => {
    if (!hasResults) return [];

    return results?.hits?.map((currentCollection) => ({
      handle: currentCollection.handle,
      omsId: currentCollection.objectID,
      title: currentCollection.titleLink || currentCollection.title,
      _tags: currentCollection._tags,
    }));
  }, [results?.hits]);

  if (!hasResults) {
    return null;
  }

  return (
    <HeroCollection
      childCollections={collectionHits}
      searchTerm={results.query}
    />
  );
};

type IAutocompleteProps = EmptyObject;

const CollectionsCarouselTags: React.FC<IAutocompleteProps> = () => {
  const { query } = useSearchBox();

  const locale = useLocale();

  if (query === '') {
    return null;
  }

  return (
    <Index
      indexName={generateCollectionIndexName(algoliaConfig.environment, locale)}
    >
      <Configure
        clickAnalytics
        hitsPerPage={5}
        filters={COLLECTION_TYPE_FILTER.SECTION}
      />
      <CollectionsResults />
    </Index>
  );
};

export default CollectionsCarouselTags;
